import http from '../common/http'

export const GetStoreListByMerchantId = () => (
  http.get('/store/GetMerchantStoreList')
)
export const GetStoreListByRepairStores = () => (
  http.post('/store/RepairStores')
)

export const GetStoreList = () => (
  http.get('/store/GetStoreList')
)
export const GetShopAddress = shopsysno => (
		http.get('/nativeApp/GetShopAddress', { shopsysno: shopsysno })
)

export const GetShopImageAudit = shopsysno => (
		http.get('/nativeApp/GetShopImageAudit', { shopsysno: shopsysno })
)

//保存门店地址信息
export const SaveShopAddress = params => (
		http.post('/nativeApp/SaveShopAddress', params)
)

//保存门店图片信息
export const SaveShopImg = params => (
		http.post('/nativeApp/SaveNetworkImg', params)
)

//获取网点及其标签,及其抖音快手核销门店编号
export const GetNetworkInfoSimplify = shopsysno => (
		http.get('/nativeApp/GetNetworkInfoSimplify', { shopsysno: shopsysno })
)



// WEBPACK FOOTER //
// ./src/api/shopApi.js